import { css } from '@emotion/react';
import { useTranslation } from '@hotjar/translations';
import { Button, tokens } from '@hotjar/hotsauce';

import { SignUpHeader } from '@hotjar/webapp/components/SignUpHeader';
import { getLoggedIn } from '@hotjar/webapp/domains/common/user-data';

export interface Page40xProps {
  redirectToLoginPage: () => void;
  title: string;
  description: string;
  goSignIn?: string;
  goDashboardOverview?: string;
  hideHeader?: boolean;
  imgSrc?: string;
}

export const Page40x = ({
  redirectToLoginPage,
  imgSrc,
  title,
  description,
  goSignIn = '',
  hideHeader = false,
  goDashboardOverview = '',
}: Page40xProps): JSX.Element => {
  const { t } = useTranslation();
  const isLoggedIn = getLoggedIn();

  return (
    <>
      {!isLoggedIn && !hideHeader && <SignUpHeader />}
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: tokens.spacer.x8,
            paddingTop: tokens.spacer.x8,
          }}
        >
          <img
            alt=""
            css={css`
              margin-bottom: ${tokens.spacer.x2};
            `}
            data-testid="image"
            src={imgSrc}
          />

          <h1
            css={css`
              ${tokens.text('header1')};
              color: ${tokens.color.text_light};
              margin-bottom: ${tokens.spacer.x2};
              line-height: inherit;
            `}
          >
            {t(title)}
          </h1>
          <p
            css={css`
              ${tokens.text('subtitle1')};
              color: ${tokens.color.text_light};
              margin-bottom: ${tokens.spacer.x4};
            `}
          >
            {t(description)}
          </p>

          {!isLoggedIn && (
            <Button size="l" data-testid="login-link" onClick={redirectToLoginPage}>
              {goSignIn || t('common:40x.go-sign-in')}
            </Button>
          )}

          {isLoggedIn && (
            <Button href="/" as="a" data-testid="dashboard-overview-link">
              {goDashboardOverview || t('common:40x.go-dashboard-overview')}
            </Button>
          )}
        </div>
      </div>
    </>
  );
};
